var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env.js';
import { JobSummary } from 'packages/v4/jobs/JobSummary';
var JobSummaryRepository = /** @class */ (function (_super) {
    __extends(JobSummaryRepository, _super);
    function JobSummaryRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v5/";
        _this.entity = JobSummary;
        _this.url = 'companies/:company/jobs';
        return _this;
    }
    JobSummaryRepository.prototype.allWithStats = function (companyId, query) {
        var _a, _b;
        if ((_b = (_a = query.queryData.filters) === null || _a === void 0 ? void 0 : _a.statuses) === null || _b === void 0 ? void 0 : _b.includes('all')) {
            delete query.queryData.filters.statuses;
        }
        return this.getPaginated(this.url, { company: companyId }, query.queryData);
    };
    return JobSummaryRepository;
}(AbstractRepository));
export { JobSummaryRepository };
